var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible && _vm.noticeText
    ? _c("div", { staticClass: "notice-bar" }, [
        _c("span", {
          staticClass: "notice-bar__text",
          domProps: { innerHTML: _vm._s(_vm.noticeText) },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "notice-bar__close",
            attrs: { "aria-label": "닫기" },
            on: { click: _vm.close },
          },
          [_vm._v("×")]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }